import type { FC } from 'react';
import React, { useState } from 'react';
import type { ModifierStyles } from 'src/routes/SeoApp/domain/state/modifier/types';
import { formatCurrency } from 'src/utils/stringUtils';
import classnames from 'classnames';
import styles from './list.module.css';

import Icon from '../../../../../components/Icon';

interface Props {
  className?: string;
  showMoreLabel: string;
  isMobile: boolean;
  list: {
    link: string;
    text: string;
    price?: number | string;
  }[];
  modifierStyles: ModifierStyles;
}

type CustomCSSProperties = {
  '--textColor'?: string;
  '--linkColor'?: string;
};

type StyleProps = React.CSSProperties & CustomCSSProperties;

export const List: FC<Props> = (props) => {
  const { className, list, showMoreLabel, isMobile, modifierStyles } = props;
  const [showAll, setShowAll] = useState(list.length <= 5);
  const handleShowMore = () => setShowAll(!showAll);

  let listCountOffset = list.length;
  const mobileCountOffset = 6;
  if (isMobile) {
    listCountOffset = showAll ? list.length : mobileCountOffset;
  }

  const dummy: any = {};

  return (
    <>
      <div className={className}>
        {list.map((item, index) => {
          const { link, text, price } = item;

          return (
            index < listCountOffset && (
              <div className={styles.listItem} key={`${link}`}>
                <a
                  className={classnames(styles.anchor, {
                    [styles.anchorLinkColor]: modifierStyles?.linkColor,
                  })}
                  style={
                    {
                      '--linkColor': modifierStyles?.linkColor,
                    } as StyleProps
                  }
                  href={link}
                >
                  {text}
                </a>
                {price ? (
                  <span
                    className={classnames(styles.price, {
                      [styles.priceTextColor]: modifierStyles?.textColor,
                    })}
                    style={
                      {
                        '--textColor': modifierStyles?.textColor,
                      } as StyleProps
                    }
                  >{`от ${formatCurrency(price)}`}</span>
                ) : null}
              </div>
            )
          );
        })}
      </div>
      {isMobile && !showAll && (
        <button
          className={classnames(styles.showMore, {
            [styles.showMoreTextColor]: modifierStyles?.textColor,
          })}
          style={
            {
              '--textColor': modifierStyles?.textColor,
            } as StyleProps
          }
          type="button"
          onClick={handleShowMore}
        >
          {showMoreLabel}
          <Icon type="arrow-down" {...dummy} />
        </button>
      )}
    </>
  );
};
